import { groupBy, map } from "lodash";
import React from "react";
import titleize from "../../titleize";
import FilterChip from "../../../components/pages/SearchPage/components/FilterChip";
import { Small } from "../../../components/elements/v2/Typography/Typography";
import { filterSizesByCountry } from "../../listingHelper";
import { useSearchPageContext } from "../../../components/pages/SearchPage/SearchPageContext";
import { useRefinementList } from "react-instantsearch";
import SizeGuide from "../../../components/composites/v2/SizeGuide/SizeGuide";
import FlexBox from "../../../components/elements/v2/Box/FlexBox";
import styled from "styled-components";
import FilterSection from "../../../components/pages/SearchPage/components/FilterSection";
import { SIZE_FIELDS_REVERSED } from "../filters";

export default function SizeFilter() {
  const { myCountry } = useSearchPageContext();
  const { items, refine, canRefine } = useRefinementList({ attribute: "size" });
  const selectedValues = items.filter((item) => item.isRefined).map((item) => item.value);
  const groupedOptions = groupBy(items, (item) => titleize(item.label.split("|")[0]));
  const hasSelectedItems = selectedValues.length > 0;

  function renderLabel(label: string) {
    return filterSizesByCountry(label, myCountry?.code);
  }

  console.log("groupedOptions", groupedOptions);

  return (
    <FilterSection label="Size" canRefine={canRefine} hasSelectedItems={hasSelectedItems}>
      {map(groupedOptions, (options, key) => (
        <div key={key} className="t-searchFilterGroup" style={{ marginBottom: "24px" }}>
          <FlexBox mb={1} justifyContent="space-between" width="100%">
            <Small>{key}</Small>
            <SizeGuide
              icon={<SizeGuideButton>Size Guide</SizeGuideButton>}
              categoryName={key}
              field={SIZE_FIELDS_REVERSED[key]}
            />
          </FlexBox>
          {map(options, (option) => (
            <FilterChip
              key={option.value}
              label={renderLabel(option.label.split("|").slice(1).join("|"))}
              onClick={() => refine(option.value)}
              $selected={selectedValues.includes(option.value)}
              size="small"
            />
          ))}
        </div>
      ))}
    </FilterSection>
  );
}

const SizeGuideButton = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;
